<template>
  <Row>
    <Col :xs="12" :l="6" class="u-textAlign--center@l-down">
      <InViewAnimation>
        <Illustration :name="image" :brush="1" brushColor="primaryCoral" />
      </InViewAnimation>
    </Col>
    <Col :xs="12" :l="6">
      <InViewAnimation :delay="2">
        <Headline slot="1" :heading="1" size="l" responsive>{{ headline[0] }}</Headline>
        <Copy
          slot="2"
          v-for="copy in copies"
          :key="`copy-${copy}`"
          size="l"
          color="primaryBlue"
          responsive
        >
          {{ copy }}
        </Copy>
      </InViewAnimation>
    </Col>
  </Row>
</template>

<script>
import Headline from '@/objects/Headline';
import Copy from '@/objects/Copy';
import Illustration from '@/objects/Illustration';
import Row from '@/components/Grid/Row';
import Col from '@/components/Grid/Col';
import InViewAnimation from '@/components/InViewAnimation';

import { mapFieldsCareService } from '@/store/mapFields';

export default {
  name: 'Overview',
  props: {
    content: Object,
  },
  components: {
    Headline,
    Copy,
    Illustration,
    Row,
    Col,
    InViewAnimation,
  },
  computed: {
    ...mapFieldsCareService(['careServiceStepIsValid']),
  },
  data() {
    return {
      ...this.content,
    };
  },
  mounted() {
    this.careServiceStepIsValid = true;
  },
};
</script>
